import React, { useEffect, useState } from 'react';
import api from '../../../../services/api';
import { data } from '../types';

export function useGetProjetosEmAndamento() {
  const [projetosEmAndamento, setProjetos] = useState<any | null>(null);
  const [loadEmAndamento, setLoad] = useState(false);

  async function handleProjetosEmAndamento(page = 1, search?: string) {
    setLoad(true);
    const { data } = await api.get('/projects', {
      params: {
        page,
        nome: search,
        filter: "Homologado/Em andamento",
      },
    });

    if (data.data.length === 0 && page > 1) {
      handleProjetosEmAndamento(page - 1);
    }

    setProjetos(data);
    setLoad(false);
  }

  useEffect(() => {
    handleProjetosEmAndamento();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    projetosEmAndamento, handleProjetosEmAndamento, loadEmAndamento,
  };
}
